"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _DAO2 = _interopRequireDefault(require("./_DAO"));

var _utils = require("./_utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InstanceConfig = {};

var InvitationService = /*#__PURE__*/function (_DAO) {
  (0, _inherits2["default"])(InvitationService, _DAO);

  var _super = _createSuper(InvitationService);

  function InvitationService() {
    (0, _classCallCheck2["default"])(this, InvitationService);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(InvitationService, [{
    key: "create",

    /**
     * Create an invitation
     * @param {Object} request - {
     *   @property {String} resourceUrl - CC Storage path (path based or ID-based)
     *   @property {Array} recipients - Array of type recipient. The type recipient is composed of the following properties
     *      recipient - is a string which can be of two types:
     *          Email Address:  The valid format for email address is mailto:{emailAddress}
     *          Address Book Entry: Address Book entries can be of two types
     *            1) Address Book Contact: The valid format for an Address Book Contact is an urn string with format- urn:ab:contact:{AddressBookID}-{ContactID}
     *            2) Address Book Group: The valid format for an Address Book Group is an urn string with format- urn:ab:group:{AddressBookID}-{ContactID}
     *   @property {String} role - Role to be assigned to the recipients.
     *   @property {String} useMounts - Specifies if a mount (aka mount point) to the resource needs to be created for the invitee. This value cannot be TRUE when acceptanceRequired is FALSE
     *   @property {String} acceptanceRequired - Specifies if the invitee needs to accept the invitation to collaborate on the resource. When acceptanceRequired is FALSE, the invitee is added as a collaborator on the resource.
     *   @property {Object} ansNotification - (Optional - {} to send ANS notification, null to not send ANS notification
     *   @property {Object} emailNotification - (Optional - Required if acceptanceRequired is FALSE)
     *      This parameter is a map of Key = notifType (string) and Value = emailTemplate (object)
     *      There are three possible values for the key in the map:
     *      a) acceptance: Email notification when acceptanceRequired is set to TRUE
     *      b) sharing: Email notification when acceptanceRequired is set to FALSE
     *      c) response: (PHASE 2) Email template that will be used to construct the forwarded invitation request for access response email message.
     *                             The template should have conditional parameters so that it can handle both accepted and rejected scenarios.
     *      emailTemplate contains the following template information used to construct the email:
     *        templateName (Required): ID of template registered with APO (Adobe Post Office)
     *        locale (Required): Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code (e.g., “EN_US”)
     *        parameters (Optional): User provided map of key-value pairs needed to construct the template. The list of predefined parameters will be set in the template.
     *   @property {String} message - (Optional) A custom message for the inviter to add to the invite notification. The corresponding email param is Param_Custom_Message.
     *   @property {String} resourceViewUrl - (Optional) A custom message for the inviter to add to the invite notification. The corresponding email param is Param_Custom_Message.
     *   @property {String} captcha - (Optional) This parameter includes the following properties:
     *                   userResponse: (Optional) recaptcha User Response
     *                   siteKey:(Optional) recaptcha Site Key
     * }
     *
     * @return {Promise} A Promise that invites the list of recipients
     *
     * @example
     *  request: {
     *    resourceUrl: "https://cc-api-storage-stage.adobe.io/id/urn:aaid:sc:US:86633ca9-1c6b-4e03-bfa1-3f7c79a6d8f3",
     *    recipients: [
     *      "recipient": "mailto:user@adobe.com",
     *      "recipient": "urn:ab:contact:Address_Book_ABCD:123456",
     *      "recipient": "urn:ab:group:Address_Book_ABCD:123",
     *    ],
     *    role: "editor",
     *    useMounts: true,
     *    acceptanceRequired: true,
     *    ansNotification: {},
     *    emailNotification: {
     *      "acceptance": {
     *        "templateName": "template_name_123",
     *        "parameters": {
     *          "key1": "value1",
     *          "key2": "value2",
     *          "key3": "value3"
     *        },
     *        "locale": "EN_US"
     *      },
     *      "sharing": {
     *        "templateName": "template_name_123",
     *        "parameters": {
     *          "key1": "value1",
     *          "key2": "value2",
     *          "key3": "value3"
     *        },
     *        "locale": "EN_US"
     *      }
     *    },
     *    message : "this is a comment",
     *    captcha: {
     *      "userResponse": "CAPTCHA_USER_RESPONSE_TOKEN",
     *      "siteKey": "CAPTCHA_SITE_KEY"
     *    }
     *  }
     */
    value: function create() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = "".concat(this._endpoint, "/invitations");
      var resourceUrl = request.resourceUrl,
          recipients = request.recipients,
          role = request.role,
          useMounts = request.useMounts,
          acceptanceRequired = request.acceptanceRequired,
          ansNotification = request.ansNotification,
          emailNotification = request.emailNotification,
          message = request.message,
          recaptcha = request.recaptcha,
          resourceViewUrl = request.resourceViewUrl;
      var notification = {
        ans: ansNotification,
        email: emailNotification,
        parameters: {
          message: message,
          resourceViewUrl: resourceViewUrl
        }
      };
      var params = {
        acceptanceRequired: acceptanceRequired,
        captcha: recaptcha,
        notification: notification,
        recipients: recipients,
        resourceUrl: resourceUrl,
        role: role,
        useMounts: useMounts
      };
      return this.postRequest({
        url: url,
        params: params
      });
    }
    /**
     * SDK method that parses and determines if invite is disabled, or if UGC (adding messages) to invite creation is disabled.
     * @returns {String} One of the following values: UGC_ENABLED, UGC_DISABLED, INVITE_DISABLED
     */

  }, {
    key: "getInviteCapability",
    value: function getInviteCapability() {
      return this.getCapabilities('customization').then(function (response) {
        if (response.status == 403) {
          return 'INVITE_DISABLED';
        } else if (response.headers && response.headers.get('x-customization') === false) {
          return 'UGC_DISABLED';
        }

        return 'UGC_ENABLED';
      })["catch"](function (error) {
        // Return enabled if call failed.
        console.error(error);
        return 'UGC_ENABLED';
      });
    }
  }, {
    key: "sendVerificationEmail",
    value: function sendVerificationEmail(url) {
      return this.getRequest({
        url: url
      });
    }
  }]);
  return InvitationService;
}(_DAO2["default"]);

var _default = (0, _utils.InstanceCreator)(InvitationService, InstanceConfig);

exports["default"] = _default;